import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ItemSyncStatusApi } from '@/lib/api/work-integrations/itemSyncStatus';
import { invalidateAfterItemSyncMutation } from '@/lib/hooks/items/invalidateAfterItemSyncMutation';

export const useAssignItemIntegrationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      itemId,
      integrationId,
      currentIntegrationId,
    }: {
      itemId: number;
      integrationId: number;
      currentIntegrationId?: number;
    }) => {
      if (currentIntegrationId === undefined) {
        return ItemSyncStatusApi.markItemAsPending({ itemId, integrationId });
      }
      return ItemSyncStatusApi.replacePendingIntegration({ itemId, integrationId });
    },
    onSuccess: () => {
      invalidateAfterItemSyncMutation(queryClient);
    },
  });
};
